<div class="bg-white p-8">
  <div class="mx-auto max-w-screen-xl">
    <h2 class="text-xl text-azul sm:text-2xl animate-fade-right">{{'carro-compra' | translate}}</h2>
    <div class="mt-6 sm:mt-8 md:gap-6 lg:flex lg:items-start xl:gap-8">
      <!-- Contenedor Productos Carrito -->
      <div class="mx-auto w-full flex-none lg:max-w-2xl xl:max-w-4xl">
        <div class="space-y-6">
          <div *ngFor="let producto of productosCarrito" class="rounded-lg border-2 border-azul bg-white p-4 md:p-6 animate-fade shadow-2xl shadow-gray-600 transition duration-300 ease-in-out hover:-translate-y-2">
            <div class="space-y-4 md:flex md:items-center md:justify-between md:gap-6 md:space-y-0">
              <a href="/producto/{{producto.producto.ID}}" class="shrink-0 md:order-1">
                <img class="h-32 w-32" src="{{producto.producto.imagen}}" alt="{{producto.producto.nombre}}" />
              </a>
              <div class="text-start md:text-end md:order-4 md:w-32">
                <p class="text-base font-bold text-azul">{{producto.producto.precio * producto.cantidad}} €</p>
              </div>
              <div class="w-full min-w-0 flex-1 space-y-4 md:order-2 md:max-w-md">
                <a href="/producto/{{producto.producto.ID}}" class="text-base font-medium text-azul hover:text-blue-300 duration-1000">{{producto.producto.nombre}}</a>
                <p class="text-base font-medium text-azul">{{'cantidad' | translate}} {{producto.cantidad}}</p>
                <p class="text-base font-medium text-azul">{{'talla' | translate}} {{producto.talla}}</p>
                <div class="flex items-center gap-4">
                  <button type="button" (click)="eliminarProducto(producto.producto.ID, producto.talla)" class="inline-flex items-center text-sm font-medium text-red-600 hover:underline dark:text-red-500">{{'eliminar-producto' | translate}}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Contenedor Resumen Pedido -->
      <div class="mx-auto mt-6 max-w-4xl flex-1 space-y-6 lg:mt-0 lg:w-full animate-fade-left">
        <div class="space-y-4 rounded-lg border-2 border-azul bg-white p-4 sm:p-6 shadow-2xl shadow-gray-600">
          <p class="text-xl font-semibold text-azul">{{'resumen-pedido' | translate}}</p>
          <div class="space-y-4">  
            <dl class="flex items-center justify-between gap-4 border-t border-azul pt-2">
              <dt class="text-base font-bold text-black">Total:</dt>
              <dd class="text-base font-bold text-black">{{obtenerImporteTotal()}} €</dd>
            </dl>
          </div>
          <a href="/pasarelapago" class="flex w-full items-center justify-center rounded-lg bg-azul px-5 py-2.5 text-sm font-medium text-white hover:text-blue-300 duration-1000">{{'proceder-compra' | translate}}</a>
          <div class="flex items-center justify-center gap-2">
            <span class="text-sm font-normal text-gray-500"> {{'o' | translate}} </span>
            <a routerLink="/tienda" title="" class="inline-flex items-center gap-2 text-sm font-medium text-primary-700 underline hover:text-blue-300 duration-1000">{{'continuar-comprando' | translate}}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>